import React from "react";
import { LeadingIcon } from "@nykaa/payment-ui/src/Icon";
import { TitleBundle } from "@nykaa/payment-ui/src/TitleBundle";
import { Text } from "@nykaa/payment-ui/src/Text";
import { ToggleSwitch } from "components/ToggleSwitch";
import { WalletFailureMethodComponentProps } from "../@types";
import { ToggleWrapper, WalletTileLayout } from "../assets/style";


const WalletFailureMethodComponent = ({
  leadingIconUrl,
  theme,
  isWalletChecked,
  handleWalletToggle,
  rightText,
  title,
  titleFont = theme?.typography?.bodyLarge,
  subtitleFont = theme?.typography?.bodyMedium,
}: WalletFailureMethodComponentProps) => (
  <WalletTileLayout>
    {leadingIconUrl && <LeadingIcon icon={leadingIconUrl} theme={theme} />}
    <TitleBundle title={title} titleFont={titleFont} theme={theme} />
    {rightText && <Text text={rightText} font={subtitleFont} theme={theme} />}
    <ToggleWrapper>
      <ToggleSwitch isChecked={isWalletChecked} onToggle={handleWalletToggle} />
    </ToggleWrapper>
  </WalletTileLayout>
);

export default WalletFailureMethodComponent;
